import React from "react";
import {Link} from "react-router-dom";
import {FaInstagram, FaTelegram} from "react-icons/all";
// import imgIos from "../../../../images/btns-dl/btn-dl-ios.png";
import imgAndroid from "../../../../images/btns-dl/btn-dl-android.png";
import imgAndroidBaazaar from "../../../../images/btns-dl/btn-dl-baazaar.png";
import {ANDROID_APP_DOWNLOAD_URL, ANDROID_APP_DOWNLOAD_BAAZAAR_URL, FRUITMRUIT_SUPPORT_PHONE} from "../../../../apis";

import Fab from '@mui/material/Fab';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';


const Footer = () => {
    return (
        <div className="row" id="footer">
            <div className="col">
                <div className="row mt-3">
                    <div className="col-12 col-md-6 col-lg">
                        <div className="row">
                            <div className="col-3 col-sm-4">
                                <hr className="line-title-hr"/>
                            </div>
                            <div className="col-6 col-sm-4">
                                <h5 className="text-center">فروت مروت</h5>
                            </div>
                            <div className="col-3 col-sm-4">
                                <hr className="line-title-hr"/>
                            </div>
                        </div>
                        <div className="row text-about-footer">
                            <div className="col-12">
                                <p className="text-justify">
                                    فروت مروت فروشگاه آنلاین مواد غذایی تازه و روزانه با ارسال سریع به تمام نقاط شیراز
                                    حتی در کمتر از یک ساعت می باشد که مواردی همچون گارانتی بی قید و شرط مرجوع یا
                                    جایگزینی سفارش ها و همچنین پشتیبانی اختصاصی و پاسخگو از ویژگی های منحصر به فرد این
                                    مجموعه می باشد.
                                </p>
                                {/* <p>
                                    کدملی: 2452152692
                                    <br />
                                    Zp.1927179
                                    <br />
                                    رضا زارعی
                                    <br />
                                    جهت راستی  آزمایی زرین پال
                                </p> */}
                            </div>
                            {/*<div className="col-12" id="btn-group-app">
                                <div className="row">
                                    <div className="col">
                                        <img src={imgAndroid}
                                             alt="btn-download-android"
                                             onClick={() =>window.open(ANDROID_APP_DOWNLOAD_URL)}/>
                                    </div>
                                    <div className="col">
                                        <img src={imgIos}
                                             alt="btn-download-ios"/>
                                    </div>
                                </div>
                            </div>*/
                            <div className="col-12" id="btn-group-app">
                                <div className="row">
                                    <div className="col">
                                        <img src={imgAndroid}
                                             alt="btn-download-android"
                                             onClick={() =>window.open(ANDROID_APP_DOWNLOAD_URL)}/>
                                    </div>
                                    <div className="col">
                                        <a href={ANDROID_APP_DOWNLOAD_BAAZAAR_URL} target="_blank" rel="noreferrer" title="دانلود از کافه بازار">
                                            <img src={imgAndroidBaazaar} alt="دانلود از کافه بازار" />
                                        </a>
                                    </div>
                                </div>
                            </div>}
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg">
                        <div className="row">
                            <div className="col-3 col-sm-4">
                                <hr className="line-title-hr"/>
                            </div>
                            <div className="col-6 col-sm-4">
                                <h5 className="text-center">ارتباط با فروت مروت</h5>
                            </div>
                            <div className="col-3 col-sm-4">
                                <hr className="line-title-hr"/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                {/*<address>
                                    <span>آدرس :</span>
                                    <span>شيراز- میرزای شیرازی کوچه ۷، کوچه ۲۶،ساختمان ارس</span>
                                </address>*/}
                                <p>
                                    <span>تلفن همراه: </span>
                                    <span dir={'ltr'}><a href="tel:09178788917">0917 878 8917</a></span>
                                </p>
                                <p>
                                    <span>ایمیل : </span>
                                    <span><a href="mailto:info@fruitmruit.com">info@fruitmruit.com</a></span>
                                </p>
                                {/*<p>ارتباط از طریق ارسال پیام</p>*/}
                                <div id="social-networks">
                                    <FaInstagram
                                        className={'item-social-networks'}
                                        onClick={() =>window.open("https://www.instagram.com/fruitmruit/")}
                                    />
                                    <FaTelegram className={'item-social-networks'}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg">
                        <div className="row">
                            <div className="col-3 col-sm-4">
                                <hr className="line-title-hr"/>
                            </div>
                            <div className="col-6 col-sm-4">
                                <h5 className="text-center">مجوز های فروت مروت</h5>
                            </div>
                            <div className="col-3 col-sm-4">
                                <hr className="line-title-hr"/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col text-center">
                                <img className="img-responsive" id="jxlzesgtesgtesgtnbqejzpeoeuk"
                                     style={{cursor: 'pointer'}}
                                     onClick={
                                         () => {
                                             window.open('https://logo.samandehi.ir/Verify.aspx?id=1000278&amp;p=rfthobpdobpdobpduiwkjyoemcsi', 'Popup', 'toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30')
                                         }
                                     }
                                     alt="logo-samandehi"
                                     src="https://logo.samandehi.ir/logo.aspx?id=1000278&amp;p=nbpdlymalymalymaodrfyndtaqgw"/>

                                {/*<img className="img-responsive"
                                     src="https://trustseal.enamad.ir/logo.aspx?id=87652&amp;p=t2Uzz5nSYXZTHAKN"
                                     alt="samandehi"
                                     onClick={() => {
                                         window.open('https://trustseal.enamad.ir/Verify.aspx?id=87652&amp;p=t2Uzz5nSYXZTHAKN&amp;', 'Popup&amp;', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30')
                                     }}
                                     style={{cursor: 'pointer'}} id="t2Uzz5nSYXZTHAKN"/> */}
                                <img className="img-responsive"
                                     src="https://trustseal.enamad.ir/logo.aspx?id=506284&Code=JsIjEhgnJIIBUYdiitWvsz2KlOCb9Uv2"
                                     alt="enamad"
                                     onClick={() => {
                                         window.open('https://trustseal.enamad.ir/?id=506284&Code=JsIjEhgnJIIBUYdiitWvsz2KlOCb9Uv2', 'Popup&amp;', 'toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=580, height=600, top=30')
                                     }}
                                     style={{cursor: 'pointer'}} id="JsIjEhgnJIIBUYdiitWvsz2KlOCb9Uv2"/>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="row border-top">
                    <div className="col" id="list-nav-footer">
                        <div id="nav-footer">
                            <ul>
                                <li><Link to={'/stores'}>فروشگاه ها</Link></li>
                                <li><Link to={`/more-pages/about-us`}> درباره ما</Link></li>
                                <li><Link to={`/more-pages/rules`}> قوانین و مقررات</Link></li>
                                <li><Link to={`/more-pages/contact-us`}> تماس با ما</Link></li>
                                <li><Link to={`/more-pages/complaint`}> انتقادات و پیشنهادات</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="col text-right">
                        <div id="copy-right">
                            <p className="d-inline-block">طراحی توسط: </p>
                            <Link to="/4rk.ir" target="_blank" onClick={(event) => {
                                event.preventDefault();
                                window.open("https://4rk.ir/")
                            }}>گروه برنامه نویسی آرک</Link>
                        </div>
                    </div>
                </div>
            </div>
            <a href={`whatsapp://send?phone=${FRUITMRUIT_SUPPORT_PHONE}`}>
                <Fab 
                    color="#42b029" 
                    sx={{
                        color: 'white',
                        fontFamily: 'IYekan', 
                        '&.MuiFab-root' : { position: 'fixed', bottom: '5px', right: '5px', transform: 'translate(-50%, -50%)',  backgroundColor: '#42b029', zIndex: '1'}
                    }}
                    aria-label="whatsapp">
                    <WhatsAppIcon />
                </Fab>
            </a>
        </div>
    );
};
export default Footer;
